import styles from './HeaderButton.module.less';
import React, { CSSProperties } from 'react';

function HeaderButton(
  props: {
    iconFile: any;
    style?: CSSProperties;
    className?: string;
    onClick?: () => void;
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
  },
  ref: React.Ref<any>
) {
  return (
    <button
      ref={ref}
      onMouseOver={props.onMouseOver}
      onMouseLeave={props.onMouseLeave}
      onClick={props.onClick}
      role="button"
      style={{ backgroundImage: `url(${props.iconFile})`, ...props.style }}
      className={`${styles['header-btn']} ${props.className || ''}`}
    />
  );
}

export default React.forwardRef(HeaderButton);
